<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/inbox-workflow/contract"
  import InboxStatementCell from "./_modules/inbox-statement-cell"
  import type { WrongRecipientReplacementDraft, WrongRecipientReplacementRow } from "../../contract"

  let props: InboxWorkflowCellProps<WrongRecipientReplacementRow, WrongRecipientReplacementDraft> =
    $props()

  const row = $derived(props.row)
</script>

<InboxStatementCell text={row.submittedContactLabel} disabled={props.disabled} />
